<template>
  <v-card
    variant="flat"
    class="mb-4 pa-4"
  >
    <h3 class="text-h6 mb-4">
      User Information
    </h3>
    <v-form>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="user.first_name"
            label="First Name*"
            variant="outlined"
            :rules="[v => !!v || 'First name is required']"
            required
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="user.last_name"
            label="Last Name*"
            variant="outlined"
            :rules="[v => !!v || 'Last name is required']"
            required
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="organization.name"
            label="Company/Organization Name*"
            variant="outlined"
            :rules="[v => !!v || 'Company name is required']"
            required
          />
        </v-col>
      </v-row>
    </v-form>
  </v-card>

  <v-card
    variant="flat"
    class="mb-4 pa-4"
  >
    <h3 class="text-h6 mb-4">
      Profile Information
    </h3>
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <v-select
            v-model="profile.about"
            label="Tell us about yourself*"
            :items="[
              `I am evaluating ${brand.brandName} products`,
              'I am a current customer',
              'I am a system integrator',
              'I am a consultant',
              'Other'
            ]"
            variant="outlined"
            :rules="[v => !!v || 'This field is required']"
            required
          />
        </v-col>
  
        <v-col cols="12">
          <v-autocomplete
            v-model="profile.country"
            label="Country/Location*"
            :items="countries"
            item-title="title"
            item-value="value"
            variant="outlined"
            :rules="[v => !!v || 'Country is required']"
            required
          />
        </v-col>
  
        <v-col cols="12">
          <v-select
            v-model="profile.business_title"
            label="Business Title*"
            :items="[
              'CEO/President/Owner',
              'CTO/Technical Director',
              'Engineering Manager',
              'Senior Engineer',
              'Engineer',
              'Product Manager',
              'Consultant',
              'Other'
            ]"
            variant="outlined"
            :rules="[v => !!v || 'Business title is required']"
            required
          />
        </v-col>
  
        <v-col cols="12">
          <v-select
            v-model="profile.job_description"
            label="Job Description*"
            :items="[
              'Hardware Design/Development',
              'Software Design/Development',
              'System Integration',
              'Product Management',
              'Business Development',
              'Technical Management',
              'Executive Management',
              'Other'
            ]"
            variant="outlined"
            :rules="[v => !!v || 'Job description is required']"
            required
          />
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>
  
<script setup lang="ts">
import { ref } from 'vue'

import { brand } from '@/config/brand'
import type { VForm } from 'vuetify/components'
import type { IUserProfile } from '@/models/user'
import type { IOrganization } from '@/models/organization'
import type { IUserData } from '@/models/user'
import { ALL_COUNTRIES } from '@/models/country/country.constants'

// TODO: LF-2025-03-28 - Remove this once full name is being set in the Auth0 signup process
const user = defineModel<IUserData>('user', { required: true })
const profile = defineModel<IUserProfile>('profile', { required: true })
const organization = defineModel<IOrganization>('organization', { required: true })

const form = ref<VForm | null>(null)

const countries = ALL_COUNTRIES().map(country => ({
  title: country.name,
  value: country.code
}))

defineExpose({ form })
</script> 